export default getText => key =>
  ({
    title: getText('MIA Overview', 'PatientsList_Header'),
  }[key])
